import React from 'react';
import { AddButton } from '../buttons';

export const NoItemsYet = ({ text, styles, containerStyles, image, subTitle, height, btnText, handleAdd, renderButton }) => {
    return (
        <>
            {image ? (
                <div className="no-items-by-image-box" style={{ height, ...containerStyles }}>
                    <img src={image} alt="No Items" />
                    <p>{text}</p>
                    <span className="no-items-subtitle">{subTitle}</span>

                    {btnText && (
                        <div style={{ width: 'fit-content', marginTop: 24 }}>
                            <AddButton styles={{ width: 'fit-content' }} text={btnText} handleClick={handleAdd} />
                        </div>
                    )}

                    {renderButton && renderButton()}
                </div>
            ) : (
                <div className="no-items-box" style={{ ...containerStyles }}>
                    <p style={{ ...styles }}>{text}</p>
                </div>
            )}
        </>
    );
};
